export const getCookieName = (config, key) => {
  return `${config.public.onedeskFrontendCookiePrefix || ''}${key}`
}
